module.exports = "//static.hsappstatic.net/academy-achievements-public-ui/static-1.43/images/white-circle-3.svg"